
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MHeader',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  }
})
